/* eslint-disable camelcase */
interface OtpInfoProps {
  maskedPhoneNumber?: string;
  otpRefNo?: string;
  lastLoginDate: string;
  lastFailedLoginDate: string;
}

export const OTP_TIME = 180;
export const OTP_TIME_MINUTES = 3;
export const OTP_TIME_SECONDS = 0;
export const OTP_RELOGIN = "Y";
